const { h } = require('preact')

module.exports = (props) => {
  return <div class="uppy-Provider-loading">
    <span>Loading...</span>
  </div>
}
